// R45: Eén gedeelde IntersectionObserver. Bij eerste keer in beeld → prefetch.
import { useEffect, useRef } from "react";
import { prefetchOrderLines } from "@/lib/orderLinesPrefetch";

let observer: IntersectionObserver | null = null;
const elToOrderid = new WeakMap<Element, number>();

function getObserver() {
  if (observer) return observer;
  if (typeof IntersectionObserver === "undefined") return null;
  observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const id = elToOrderid.get(entry.target);
        if (id != null) {
          prefetchOrderLines(id);
          observer!.unobserve(entry.target);
        }
      }
    },
    { rootMargin: "200px 0px", threshold: 0.01 },
  );
  return observer;
}

export function usePrefetchOnVisible(orderid: number | null) {
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || orderid == null) return;
    const obs = getObserver();
    if (!obs) {
      prefetchOrderLines(orderid);
      return;
    }
    elToOrderid.set(el, orderid);
    obs.observe(el);
    return () => {
      try { obs.unobserve(el); } catch { /* noop */ }
    };
  }, [orderid]);
  return ref;
}
